import { metricMotion, sectionMotion, tableRowMotion } from '../animations/MotionContainers'

export const pageTransition = {
  initial: 'hidden',
  animate: 'visible',
  exit: 'exit',
}

export const cardTransition = {
  initial: 'hidden',
  animate: 'visible',
  variants: sectionMotion,
}

export const listItemTransition = () => ({
  initial: 'hidden',
  animate: 'visible',
  variants: tableRowMotion,
})

export const metricTransition = {
  initial: 'hidden',
  animate: 'visible',
  variants: metricMotion,
}
